/* Capacidades del navegador que deciden qué hace el CSS y qué tiene que
   replicar el JS. Las scroll-driven animations (`animation-timeline`) hoy sólo
   están en Chromium; donde no existen, los módulos hacen el fallback. */

export const reduceMotion =
  window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

const supports = (prop, value) =>
  Boolean(window.CSS && CSS.supports && CSS.supports(prop, value));

export const supportsViewTimeline = supports('animation-timeline', 'view()');
export const supportsScrollTimeline = supports('animation-timeline', 'scroll()');
